/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_PublishedRolesGroupedVm } from '../models/PagedResultDto_PublishedRolesGroupedVm';
import type { PagedResultDto_PublishedRolesVm } from '../models/PagedResultDto_PublishedRolesVm';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class RolePublishService {

    /**
     * @param destinationCompanyId 
     * @param sourceRoleId 
     * @param filter 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_PublishedRolesVm OK
     * @throws ApiError
     */
    public static getApiCustomerApiCustomerCustomerSuccessRolesPublished(
destinationCompanyId?: string,
sourceRoleId?: string,
filter?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_PublishedRolesVm> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/customer/customer-success/roles/published',
            query: {
                'DestinationCompanyId': destinationCompanyId,
                'SourceRoleId': sourceRoleId,
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param destinationCompanyId 
     * @param sourceRoleId 
     * @param filter 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_PublishedRolesGroupedVm OK
     * @throws ApiError
     */
    public static getApiCustomerApiV2CustomerCustomerSuccessRolesPublished(
destinationCompanyId?: string,
sourceRoleId?: string,
filter?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_PublishedRolesGroupedVm> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/v2/customer/customer-success/roles/published',
            query: {
                'DestinationCompanyId': destinationCompanyId,
                'SourceRoleId': sourceRoleId,
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
